import { render, staticRenderFns } from "./PosReportPromotions.vue?vue&type=template&id=32faa5b6&"
import script from "./PosReportPromotions.vue?vue&type=script&lang=js&"
export * from "./PosReportPromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports